import { useEffect, useState } from "react";
import type { ColumnsType } from "antd/es/table";
import { usePermissionStore } from "@/store/PermissionStore";
import {
  getPermissionTableColumn,
  getPermissionTableData,
} from "@/pages/authorization-management/components/auth-detail-table/helper/tableTransform";

export interface IAuthDetailCheckboxInfo {
  id: number;
  authority: string;
  isOnlyView?: boolean;
}

export interface IAuthDetailTableData {
  moduleAuthority: string;
  authObject: IAuthDetailCheckboxInfo;
  permissions: IAuthDetailCheckboxInfo[];
}

export function useAuthDetailTable() {
  const [columns, setColumns] = useState<ColumnsType<IAuthDetailTableData>>();
  const [tableData, setTableData] = useState<IAuthDetailTableData[]>();

  const { allPermission } = usePermissionStore();

  useEffect(() => {
    setColumns(getPermissionTableColumn(allPermission));
    setTableData(getPermissionTableData(allPermission));
  }, [allPermission]);
  return {
    columns,
    tableData,
  };
}
